// src/utils/ipCapture.js

let machineIP = null;

// Detect local LAN IP
export function detectMachineIP() {
  return new Promise((resolve, reject) => {
    try {
      const pc = new RTCPeerConnection({ iceServers: [] });
      pc.createDataChannel("dummy");

      pc.onicecandidate = (event) => {
        if (!event?.candidate) return;

        const candidate = event.candidate.candidate;
        const match = candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3})/);

        if (match) {
          resolve(match[1]);
          pc.close();
        }
      };

      pc.createOffer().then((offer) => pc.setLocalDescription(offer));
    } catch (err) {
      reject(err);
    }
  });
}

// Initialize capture and return IP to caller
export async function initIPCapture(ipCallback) {
  try {
    machineIP = await detectMachineIP();

    localStorage.setItem("MACHINE_IP", machineIP);

    if (typeof ipCallback === "function") {
      ipCallback(machineIP); 
    }
  } catch (err) {
    console.error("❌ IP capture failed:", err);
  }
}
